import { render, staticRenderFns } from "./devicebelong.vue?vue&type=template&id=47f40e64&scoped=true&"
import script from "./devicebelong.vue?vue&type=script&lang=js&"
export * from "./devicebelong.vue?vue&type=script&lang=js&"
import style0 from "./devicebelong.vue?vue&type=style&index=0&id=47f40e64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f40e64",
  null
  
)

export default component.exports